// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fba1g","clinicsSelect":"styles_clinicsSelect__ZZ-X8"};